import React from "react";
import { CaretLeft } from "@phosphor-icons/react";

/**
 * Reusable scrollable info / settings sub-page. Used by Help, Privacy,
 * Language picker, Home currency picker, etc.
 *
 * `onTitleTap` (optional) — fires on every tap of the title text.
 * Lets parents implement hidden multi-tap unlocks (e.g. About TipLingo
 * taps 5× → reveal Connection Diagnostics for App Review / support).
 * The title itself stays visually unchanged so normal users see no
 * affordance.
 */
export default function InfoPage({ title, onBack, children, onTitleTap }) {
  return (
    <div className="min-h-screen bg-bone pb-12" data-testid="info-page">
      <div className="px-5 pt-4 flex items-center gap-3">
        <button
          type="button"
          onClick={onBack}
          aria-label="Back"
          className="w-10 h-10 rounded-full bg-white shadow-soft border border-navy/10 flex items-center justify-center"
        >
          <CaretLeft size={20} weight="bold" color="#0E2C54" />
        </button>
        <h2
          className="font-jakarta font-extrabold text-navy text-xl flex-1 select-none"
          onClick={onTitleTap}
          data-testid="info-page-title"
        >
          {title}
        </h2>
      </div>

      <div className="px-5 mt-5 space-y-4">{children}</div>
    </div>
  );
}
